import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { ScopeSelector } from "@packages/core-client/scope/ScopeSelector.tsx";
import { useQuery } from "@tanstack/react-query";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useAnalyticsScopeClient } from "../api/query.ts";
import { useEngagementScope, useEngagementTimeFrame, useHeatmapCellMode } from "../hooks/useEngagementFilters.ts";
import { i18NextInstanceKey } from "../i18n/i18next.ts";
import { EngagementPageActions } from "./EngagementPageActions.tsx";
import { EngagementPeriodToolbar } from "./EngagementPeriodToolbar.tsx";

export function EngagementFiltersHeading() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("EngagementFiltersHeading", { i18n: i18nextInstance });
    const [scope, setScope] = useEngagementScope();
    const [timeFrame, setTimeFrame] = useEngagementTimeFrame();
    const [cellMode] = useHeatmapCellMode();
    const { pathname } = useLocation();
    const scopeClient = useAnalyticsScopeClient();

    const { data: previews, isPending } = useQuery(createQueryOptions(scopeClient.getPreviews.queryOptions(), { throwOnError: false }));

    const isHeatmapScoreMode = pathname.endsWith("/heatmap") && cellMode === "score";

    return (
        <div className="flex flex-col gap-8">
            <p className="text-muted-fg">{t("subtitle")}</p>
            <ScopeSelector
                scope={scope}
                onScopeChange={setScope}
                previews={previews}
                isPreviewsPending={isPending}
                trailingContent={<EngagementPeriodToolbar timeFrame={timeFrame} onTimeFrameChange={setTimeFrame} disabledReason={isHeatmapScoreMode ? t("heatmapScoreModeDisabledReason") : undefined} />}
            />
            <EngagementPageActions />
        </div>
    );
}
